import {
	Component,
	ElementRef,
	forwardRef,
	HostListener,
	ViewChild,
} from "@angular/core";
import {
	NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {BoxValueAccessor} from "@shared/box-value-accessor/BoxValueAccessor";

@Component({
	selector: "app-time-picker",
	templateUrl: "./time-picker.component.html",
	styleUrls: ["./time-picker.component.scss"],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => TimePickerComponent),
			multi: true,
		},
	],
})
export class TimePickerComponent extends BoxValueAccessor<string> {
	@ViewChild("hoursInput") public hoursInput?: ElementRef<HTMLInputElement>;

	public hours = "00";
	public readonly minutes = "00";
	public isDisabled = false;
	public isDropdownOpen = false;

	public hoursList: string[] = Array.from({ length: 24 }, (_, i) =>
		i.toString().padStart(2, "0")
	);

	@HostListener("document:click", ["$event"])
	public clickOut(event: MouseEvent) {
		if (!this.elementRef.nativeElement.contains(event.target)) {
			this.isDropdownOpen = false;
		}
	}

	constructor(private elementRef: ElementRef) {
		super();
	}

	public writeValue(value: string): void {
		const [hour] = (value || "").split(":");
		this.hours = this.formatHours(hour);
	}

	public setDisabledState(isDisabled: boolean): void {
		this.isDisabled = isDisabled;
	}

	public onHoursFocus(): void {
		this.hoursInput?.nativeElement.select();
	}

	public onHoursInput(event: Event): void {
		event.stopPropagation();
		const input = this.hoursInput?.nativeElement;
		const value = input.value.replace(/\D/g, "");

		const num = parseInt(value.slice(-2), 10);
		this.hours = !isNaN(num) && num > 23 ? "23" : value.slice(-2);
		input.value = this.hours;

		this.emitValue();
	}

	public onHoursBlur(): void {
		this.hours = this.formatHours(this.hours);
		this.emitValue();
	}

	public toggleDropdown(event: MouseEvent): void {
		event.stopPropagation();
		if (!this.isDisabled) {
			this.isDropdownOpen = !this.isDropdownOpen;
		}
	}

	public selectHour(hour: string): void {
		this.hours = hour;
		this.isDropdownOpen = false;
		this.emitValue();
		this.hoursInput?.nativeElement.focus();
	}

	private emitValue(): void {
		this.onChange(`${this.hours.padStart(2, "0")}:${this.minutes}`);
		this.onTouched();
	}

	private formatHours(value: string): string {
		const num = parseInt(value, 10);
		if (isNaN(num) || num < 0) return "00";
		if (num > 23) return "23";
		return num.toString().padStart(2, "0");
	}
}
